<template lang="pug">
  #app
    AgeModal
    SiteHeader(:settingsData="settings")
    CookieConsent
    router-view
    Newsletter(:settingsData="settings")
    SiteFooter(:settingsData="settings")
</template>

<script>
// @ is an alias to /src
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import Newsletter from '@/components/Newsletter.vue'
import AgeModal from '@/components/AgeModal.vue'
import CookieConsent from '@/components/CookieConsent.vue'

export default {
  name: 'home',
  components: {
    SiteHeader,
    SiteFooter,
    Newsletter,
    AgeModal,
    CookieConsent
  },
  data () {
    return {
      settings: null
    }
  },
  methods: {
    async getContent () {
      const response = await this.$prismic.client.getSingle('settings')
      this.settings = response.data
    }
  },
  created () {
    this.getContent()
    let ageVerified = this.$cookies.get("ppr_ageVerified")
    if (ageVerified === 'true') {
      document.querySelector('body').setAttribute('class', '')
    } else {
      document.querySelector('body').setAttribute('class', 'overlay')
    }
  },
  mounted () {
    let cookiesConsented = this.$cookies.get("ppr_cookiesConsented")
    if (cookiesConsented === 'true') {
      document.querySelector('.cookie-agreement').setAttribute('class', 'cookie-agreement hidden')
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.getContent()
    next()
  }
}
</script>

<style lang="stylus">
#app
  position relative
</style>
